// src/utils/apiHelper.ts

export async function handleApiResponse(response: Response) {
    let data: any;
    try {
      data = await response.json();
    } catch {
      data = { detail: "Something went wrong" };
    }
  
    console.log("🔍 API Response Data:", data);
  
    // 🔑 Token expire ya invalid
    if (
      response.status === 401 ||
      response.status === 403 ||
      data?.detail?.toLowerCase().includes("invalid or expired token") ||
      data?.detail?.toLowerCase().includes("not authenticated")
    ) {
      localStorage.removeItem("adminToken");
      window.location.href = "/login"; // Next.js redirect
      return Promise.reject(new Error("Session expired. Please login again."));
    }
  
    if (!response.ok) {
      throw new Error(data.detail || "API request failed");
    }
  
    return data;
  }
  